export class RmRatesReportReq {
    countRangeId?: string;
    status?:string
    fromDate?:string 
    toDate?:string
    rateDate?:string
    productId?:number
    constructor(countRangeId?: string,status?:string,fromDate?:string,toDate?:string,rateDate?:string,productId?:number){
        this.countRangeId = countRangeId;
        this.status = status
        this.fromDate = fromDate
        this.toDate = toDate
        this.rateDate = rateDate
        this.productId = productId
    }
}
